import { api } from "../utils/api";

function unwrapNotificationList(body) {
  if (Array.isArray(body)) {
    return body;
  }
  if (body && Array.isArray(body.data)) {
    return body.data;
  }
  if (body && Array.isArray(body.items)) {
    return body.items;
  }
  return [];
}

const getNotifications = async page => {
  const res = await api.get(`Notifications`, {
    params: { page }
  });
  const raw = res.data;
  const list = unwrapNotificationList(raw);

  const notifications = list.map(notification => ({
    id: notification.id,
    type: notification.model,
    modelId: notification.modelId,
    title: notification.message,
    createdAt: notification.created_at,
    opened: notification.subscriber.opened,
    subscriber: notification.subscriber,
    ackRequired: Boolean(notification.ackRequired),
    action: notification.action || null
  }));
  return notifications;
};

const getNotificationCount = async () => {
  const res = await api.get(`Notifications/count`);
  const n = res.data;
  if (typeof n === "number" && !Number.isNaN(n)) {
    return { ...res, data: n };
  }
  if (n && typeof n === "object" && typeof n.count === "number") {
    return { ...res, data: n.count };
  }
  return res;
};

const markAsRead = async id => {
  return api.put(`Notifications/${id}/read`);
};

export default {
  getNotifications,
  getNotificationCount,
  markAsRead
};
